import React from 'react'
import { PageWrapper  } from '../pages.styled'
 
export default function MyCreatedListingsPage() {
     

    return (
        <PageWrapper> 
        </PageWrapper>
    )
}
